@if (loading) {
  <div class="spinner" [ngClass]="spinnerColorClass"></div>
}
@if (egType === 'prev') {
  <img src="/assets/icons/arrows/back.svg" alt="PREV" />
}
<ng-content></ng-content>
@if (egType === 'next') {
  <img src="/assets/icons/arrows/next.svg" alt="NEXT" />
}
